module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tip":"It would be useful for the HR-manager","refuse":"Refuse","cancel":"Cancel","successMessage":"Thanks for your feedback. We will no longer communicate with you about this job."}}')
  delete Component.options._Ctor
}
